<template>
    <div id="login-frame">
        <div class="container is-max-desktop auth-card columns">

            <div class="column is-7 left-side">

                <b-message type="is-warning" class="is-hidden-desktop is-block-tablet is-block-mobile">
                    <i class="fak fa-solid-mobile-screen-button-slash mr-3"></i>For the best experience please use a Desktop, Laptop, or Tablet device.  Mobile devices are not optimized at this time.
                </b-message>

                <!--
                <b-message type="is-success" class="is-hidden-mobile">
                    <div class="columns is-gapless">
                        <div class="column">
                            <div class="is-size-6 has-text-weight-bold">Welcome to Our New Site!</div>

                            <div class="is-size-7 mt-3">Things might look a bit different now but you are in the right place! If you have any questions feel free to contact us at <a href="mailto:support@my247ed.com">support@my247ed.com</a>.</div>
                        </div>
                    </div>
                </b-message>
                -->

                <h1>
                    <strong>my</strong>247ed.com
                </h1>

                <div v-if="!requests.id && !requests.passwordOnly">
                    <p class="mb-5 is-hidden-mobile"><strong>Welcome back, </strong>please login to your account with your e-mail address or phone number.</p>

                    <section class="pt-3">
                        <b-field>
                            <b-input placeholder="E-Mail Address or Phone Number" icon="address-card" v-model="request" v-mask="mask" v-on:keyup.native.enter="submitLogin"></b-input>
                        </b-field>

                        <div class="columns">
                            <div class="column is-size-7 mt-1">
                                <router-link to="/assistance"><i class="fas fa-question-circle mr-2"></i>Login Assistance</router-link>
                            </div>
                            <div class="column is-5 has-text-right">
                                <b-button type="is-primary" icon-left="sign-in-alt" expanded :disabled="processing || invalid" @click="submitLogin">
                                    <span v-if="!processing">Login</span>
                                    <span v-else>Please wait...</span>
                                </b-button>
                            </div>
                        </div>
                    </section>

                    <div class="alert-box info mt-5" v-if="redirectTo">
                        <div class="columns is-gapless">
                            <div class="column is-narrow mr-3"><i class="far fa-arrow-right"></i></div>
                            <div class="column">
                                <span class="has-text-weight-bold">Note: </span>After login you will be automatically redirected to your requested resource.
                            </div>
                        </div>
                    </div>

                    <div class="signup mt-6">
                        <div class="columns">
                            <div class="column">
                                <p class="is-size-6">New to <strong>my</strong>247ed.com?</p>
                                <p class="is-size-7">Get started with a <strong>free</strong> account.</p>
                            </div>
                            <div class="column is-5 has-text-right">
                                <b-button tag="router-link" to="/signup" size="is-small" outlined expanded icon-left="user-plus">Sign Up</b-button>
                            </div>
                        </div>
                    </div>

                    <div class="signup mt-5 is-hidden-mobile" v-if="!quickAccess.active">
                        <div class="columns">
                            <div class="column">
                                <img class="maximize" alt="maximize" src="@/assets/partner_assets/wiaa.png" width="100"/>
                            </div>
                            <div class="column is-5 has-text-right pt-5">
                                <b-button tag="router-link" to="/wiaa-help" size="is-small" outlined expanded icon-left="circle-question">View Walk-through</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="mb-5 is-hidden-mobile" v-if="requests.name"><strong>Welcome back, </strong>{{ requests.name }}! Please choose a login method to access your account.</p>
                    <p class="mb-5 is-hidden-mobile" v-else><strong>Welcome back, </strong>please login to your account with your e-mail address or phone number.</p>

                    <div class="content requests">
                        <div class="request-option" @click="passwordActive = true" :class="{'clickable': !passwordActive}">
                            <div class="columns is-gapless is-mobile">
                                <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-lock-keyhole mr-3" aria-hidden="true"></i></div>
                                <div class="column">
                                    <h6 class="mt-2 mb-0">Login with your Password</h6>

                                    <div class="mt-5" v-if="passwordActive">
                                        <b-field>
                                            <b-input placeholder="Account Password" icon="key" type="password" v-model="password" v-on:keyup.native.enter="passwordLogin"></b-input>
                                        </b-field>

                                        <div class="columns">
                                            <div class="column is-5 has-text-right">
                                                <b-button type="is-primary" icon-left="sign-in-alt" expanded :disabled="processing || !password" @click="passwordLogin">
                                                    <span v-if="!processing">Login</span>
                                                    <span v-else>Please wait...</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!requests.passwordOnly && requests.email.value" class="request-option" @click="submitRequest(requests.email)" :class="{'clickable': !requests.email.active}">
                            <div class="columns is-gapless is-mobile">
                                <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-envelope mr-3" aria-hidden="true"></i></div>
                                <div class="column">
                                    <h6 class="mt-2 mb-0">Login with your E-Mail</h6>
                                    <p class="mt-1 is-size-6" v-if="!requests.email.active">{{ requests.email.value }}</p>

                                    <div class="mt-5" v-if="requests.email.active">
                                        <p class="mb-3 is-size-7">An e-mail has been sent to {{ requests.email.value }}. Enter your access code from your e-mail to continue:</p>

                                        <b-field>
                                            <b-input placeholder="Access Code" maxlength="5" icon="key" v-model="requests.email.access" v-on:keyup.native.enter="submitAccess(requests.email)"></b-input>
                                        </b-field>

                                        <div class="columns">
                                            <div class="column is-5 has-text-right">
                                                <b-button type="is-primary" icon-left="sign-in-alt" expanded :disabled="processing || requests.email.access.length !== 5" @click="submitAccess(requests.email)">
                                                    <span v-if="!processing">Login</span>
                                                    <span v-else>Please wait...</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="!requests.passwordOnly && requests.email_2.value" class="request-option" @click="submitRequest(requests.email_2)" :class="{'clickable': !requests.email_2.active}">
                            <div class="columns is-gapless is-mobile">
                                <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-envelope mr-3" aria-hidden="true"></i></div>
                                <div class="column">
                                    <h6 class="mt-2 mb-0">Login with your E-Mail</h6>
                                    <p class="mt-1 is-size-6" v-if="!requests.email_2.active">{{ requests.email_2.value }}</p>

                                    <div class="mt-5" v-if="requests.email_2.active">
                                        <p class="mb-3 is-size-7">An e-mail has been sent to {{ requests.email_2.value }}. Enter your access code from your e-mail to continue:</p>

                                        <b-field>
                                            <b-input placeholder="Access Code" maxlength="5" icon="key" v-model="requests.email_2.access" v-on:keyup.native.enter="submitAccess(requests.email_2)"></b-input>
                                        </b-field>

                                        <div class="columns">
                                            <div class="column is-5 has-text-right">
                                                <b-button type="is-primary" icon-left="sign-in-alt" expanded :disabled="processing || requests.email_2.access.length !== 5" @click="submitAccess(requests.email_2)">
                                                    <span v-if="!processing">Login</span>
                                                    <span v-else>Please wait...</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="!requests.passwordOnly && requests.phone.value" class="request-option" @click="submitRequest(requests.phone)" :class="{'clickable': !requests.phone.active}">
                            <div class="columns is-gapless is-mobile">
                                <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-laptop-mobile mr-3" aria-hidden="true"></i></div>
                                <div class="column">
                                    <h6 class="mt-2 mb-0">Login with your Phone</h6>
                                    <p class="mt-1 is-size-6" v-if="!requests.phone.active">{{ requests.phone.value }}</p>

                                    <div class="mt-5" v-if="requests.phone.active">
                                        <p class="mb-3 is-size-7">An SMS text message has been sent to {{ requests.phone.value }}. Enter your access code from that message to continue:</p>

                                        <b-field>
                                            <b-input placeholder="Access Code" maxlength="5" icon="key" v-model="requests.phone.access" v-on:keyup.native.enter="submitAccess(requests.phone)"></b-input>
                                        </b-field>

                                        <div class="columns">
                                            <div class="column is-5 has-text-right">
                                                <b-button type="is-primary" icon-left="sign-in-alt" expanded :disabled="processing || requests.phone.access.length !== 5" @click="submitAccess(requests.phone)">
                                                    <span v-if="!processing">Login</span>
                                                    <span v-else>Please wait...</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="!requests.passwordOnly && requests.phone_2.value" class="request-option" @click="submitRequest(requests.phone_2)" :class="{'clickable': !requests.phone_2.active}">
                            <div class="columns is-gapless is-mobile">
                                <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-laptop-mobile mr-3" aria-hidden="true"></i></div>
                                <div class="column">
                                    <h6 class="mt-2 mb-0">Login with your Phone</h6>
                                    <p class="mt-1 is-size-6" v-if="!requests.phone_2.active">{{ requests.phone_2.value }}</p>

                                    <div class="mt-5" v-if="requests.phone_2.active">
                                        <p class="mb-3 is-size-7">An SMS text message has been sent to {{ requests.phone_2.value }}. Enter your access code from that message to continue:</p>

                                        <b-field>
                                            <b-input placeholder="Access Code" maxlength="5" icon="key" v-model="requests.phone_2.access" v-on:keyup.native.enter="submitAccess(requests.phone_2)"></b-input>
                                        </b-field>

                                        <div class="columns">
                                            <div class="column is-5 has-text-right">
                                                <b-button type="is-primary" icon-left="sign-in-alt" expanded :disabled="processing || requests.phone_2.access.length !== 5" @click="submitAccess(requests.phone_2)">
                                                    <span v-if="!processing">Login</span>
                                                    <span v-else>Please wait...</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="columns mb-5">
                        <div class="column">
                            <b-button type="is-primary" size="is-small" outlined icon-left="arrow-left" @click="requests={}; passwordActive=false;">Try Login Again</b-button>
                        </div>
                        <div class="column has-text-right">
                            <a href="mailto:support@my247ed.com?subject=Login%20Assistance">
                                <b-button tag="router-link" to="/assistance" type="is-primary" icon-left="messages-question">Get Help</b-button>
                            </a>
                        </div>
                    </div>
                </div>

                <p class="legal-notice">
                    By logging in you agree to our <router-link to="/terms">Terms of Use</router-link> and <router-link to="/privacy">Privacy Policy</router-link>.
                </p>

            </div>
            <div class="column right-side content">

                <h4 class="has-text-white"><i class="far fa-fw fa-arrow-right mr-2"></i>QUICK ACCESS</h4>

                <div v-if="!quickAccess.active">

                    <img class="maximize" alt="maximize" src="@/assets/maximize.svg"/>

                    <div class="mt-5 pt-4 quick">
                        <h6 class="has-text-white"><i class="far fa-fw fa-users-class mr-3"></i>Register for a Conference</h6>
                        <b-field class="">
                            <b-input placeholder="Conference/Access Code" expanded v-model="confCode" v-on:keyup.native.enter="conferenceCheck"></b-input>
                            <p class="control">
                                <b-button type="is-primary is-light" :disabled="!confCode" @click="conferenceCheck">
                                    <i class="far fa-arrow-right"></i>
                                </b-button>
                            </p>
                        </b-field>
                    </div>
                    <div class="mt-6 quick">
                        <h6 class="has-text-white"><i class="far fa-fw fa-chalkboard-user mr-3"></i>Enroll in a Training Course</h6>
                        <b-field class="">
                            <b-input placeholder="Course/Access Code" v-model="trainingCode" expanded v-on:keyup.native.enter="trainingCheck"></b-input>
                            <p class="control">
                                <b-button type="is-primary is-light" :disabled="!trainingCode" @click="trainingCheck">
                                    <i class="far fa-arrow-right"></i>
                                </b-button>
                            </p>
                        </b-field>
                    </div>
                </div>
                <div v-else class="pt-5">
                    <div v-if="quickAccess.course" class="columns content is-gapless">
                        <div class="column is-narrow"><i class="fad fa-browsers pr-4"></i></div>
                        <div class="column">
                            <h5 class="has-text-white">{{ quickAccess.course.title }}</h5>
                            <div>Please Login or Sign Up to continue.</div>
                        </div>
                    </div>
                    <div v-if="quickAccess.conference" class="columns content is-gapless">
                        <div class="column is-narrow"><i class="fad fa-presentation pr-4"></i></div>
                        <div class="column">
                            <h5 class="has-text-white">{{ quickAccess.conference.title }}</h5>
                            <div class="logo-frame" v-if="quickAccess.conference.logo">
                                <img :src="quickAccess.conference.logo"/>
                            </div>
                            <div>Please Login or Sign Up to continue.</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="copyright mt-3 mb-6">Copyright &copy; 2001-{{ year | moment('YYYY') }}<span class="is-hidden-mobile">, Twenty Four-Seven Enterprises Inc</span>, v{{ version }}</div>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import pkg from '../../package.json';
    import {client as http} from "../http_client";

    export default {
        data: function() {
            let d = {
                request: '',
                username: '',
                password: '',
                processing: false,
                redirectTo: null,
                version: pkg.version,
                year: new Date(),
                requests: {},
                passwordActive: false,
                confCode: '',
                trainingCode: '',
                quickAccess: {
                    active: false,
                }
            };

            let remember = localStorage.getItem('remember');
            if (remember) d.request = JSON.parse(remember).email || '';

            return d;
        },
        computed: {
            ...mapGetters(['currentUser']),
            mask: function() {
                if (this.request && this.request.match(/[a-zA-Z@\.]+/)) {
                    return 'ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ';
                } else {
                    return '(ZZZ) ZZZ-ZZZZZZZZZZZZ';
                }
            },
            invalid: function() {
                return !((!this.request.match(/[a-zA-Z@\.]+/) && this.request.replace(/\D/g, '').length === 10) || this.request.match(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/));
            }
        },
        methods: {
            ...mapActions(['login', 'makeLoginCheck', 'makeLoginRequest', 'makeLoginAccess', 'getConferenceByCode', 'getEnrollments']),
            passwordLogin() {
                this.processing = true;
                this.login({username: this.request, password: this.password}).catch(err => {
                    if (err && err.message) {
                        this.$notify('error', 'Login Error', err.message, {duration: 5000, permanent: false});
                    } else if (err && err.error && err.error.text) {
                        this.$notify('error', 'Login Error', err.error.text, {duration: 5000, permanent: false});
                    } else if (err) {
                        this.$notify('error', 'Login Error', 'An unknown error occurred. Please try again later.', {duration: 5000, permanent: false});
                    }

                    setTimeout(() => {
                        this.processing = false;
                    }, 2000);
                });
            },
            submitLogin() {
                if (!this.processing) {
                    this.processing = true;
                    this.smsError = false;
                    this.request = this.request.trim();

                    this.method = (this.request.match(/@/)) ? 'email' : 'sms';
                    this.makeLoginCheck({request: this.request, method: this.method}).then(response => {
                        this.processing = false;
                        this.requests = response;
                        this.passwordActive = (response.passwordOnly);
                    }).catch(err => {
                        this.$notify('error', 'Login Error', err.data, {duration: 5000, permanent: false});

                        setTimeout(() => {
                            this.processing = false;
                        }, 2000);
                    });
                }
            },
            submitRequest(request) {
                if (!this.processing && !request.active) {
                    this.processing = true;
                    request.active = true;

                    this.makeLoginRequest({request: request, id: this.requests.id}).then(response => {
                        this.processing = false;

                    }).catch(err => {
                        this.$notify('error', 'Login Error', err.data, {duration: 5000, permanent: false});

                        setTimeout(() => {
                            this.processing = false;
                        }, 2000);
                    });
                }
            },
            submitAccess(request) {
                this.makeLoginAccess({request: request, id: this.requests.id}).then(response => {
                    this.processing = false;

                }).catch(err => {
                    this.$notify('error', 'Login Error', 'Invalid access code.  Please try again.', {duration: 5000, permanent: false});

                    setTimeout(() => {
                        this.processing = false;
                    }, 2000);
                });
            },
            conferenceCheck: function() {
                this.error = null;
                let code = this.confCode.trim().toUpperCase();

                this.getConferenceByCode(code).then(result => {
                    if (result.code.toUpperCase() === code) {
                        localStorage.setItem('redirectTo', '/conference-center/register/' + result.id);
                    } else {
                        // Include the code because it's likely their access/discount code.
                        console.log('/conference-center/register/' + result.id + '?code=' + code);
                        localStorage.setItem('redirectTo', '/conference-center/register/' + result.id + '?code=' + code);
                    }

                    this.$router.push('/register/' + result.code);
                }, err => {
                    if (err.response.status === 404) {
                        this.$notify('error', 'Conference', "I'm sorry, we can't find a conference by that code.  Please check the code and try again!", {duration: 5000, permanent: false});
                    } else {
                        window.alert('An error occurred. If you need additional help please contact us at support@my247ed.com.');
                    }
                    localStorage.removeItem('redirectTo');
                    this.redirectTo = null;
                });
                this.confCode = '';

            },
            confPreview: function() {
                // en route to the actual registration screen, we show the title of the conference they are after, just like a course
                this.getConferenceByCode(this.confCode).then(result => {
                    this.quickAccess.active = true;
                    this.quickAccess.conference = result;
                }, err => {
                    localStorage.removeItem('redirectTo');
                    this.redirectTo = null;
                });
            },
            trainingCheck: function() {
                http.get('app/courses/new/code/' + this.trainingCode, {force: true}).then(response => {
                    this.quickAccess.active = true;
                    this.quickAccess.course = response.data;
                    localStorage.setItem('redirectTo', '/course-catalog?code=' + response.data.code + '&course=' + response.data.id);
                    this.redirectTo = '/course-catalog?code=' + response.data.code + '&course=' + response.data.id;
                }).catch(err => {
                    if (err.response.status === 404) {
                        this.$notify('error', 'Course Access', 'That access code is not valid.  Either the course is no longer available or the code was incorrect.', {duration: 5000, permanent: false});
                    } else {
                        window.alert('An error occurred. If you need additional help please contact us at support@my247ed.com.');
                    }
                    localStorage.removeItem('redirectTo');
                    this.redirectTo = null;
                });
                this.trainingCode = '';

            }
        },
        watch: {
            currentUser(val) {
                if (val && val.id) {
                    localStorage.removeItem('redirectTo');

                    // Check for suspension
                    if (val.suspension_message) {
                        this.$router.push('/suspended');
                        return;
                    }

                    console.log('Redirecting to', (this.redirectTo) ? this.redirectTo : '/dashboard');
                    this.$router.push((this.redirectTo) ? this.redirectTo : '/dashboard');
                }
            }
        },
        mounted() {
            if (localStorage.getItem('redirectTo')) {
                this.redirectTo = localStorage.getItem('redirectTo');
            }

            if (localStorage.getItem('token')) {
                this.$router.push((this.redirectTo) ? this.redirectTo : '/dashboard');
            }

            if (this.$route.query.code) {
                this.trainingCode = this.$route.query.code;
                this.trainingCheck();
            }

            if (this.$route.query.confCode) {
                console.log('Conf code available.');
                this.confCode = this.$route.query.confCode;
                this.confPreview();
            }
        }
    };
</script>

<style lang="scss" scoped>
    #login-frame {
        display: flex;
        min-height: 100vh;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        background: #224C74 radial-gradient(#336699, #1e385c);

        .auth-card {
            margin: 2rem;
            border-radius: 8px;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
            flex-grow: 0;

            .left-side {
                background-color: #FFFFFF;
                padding: 4rem 3.5rem 4rem 3.5rem;
                border-radius: 5px 0 0 5px;
                color: #666666;

                strong {
                    color: #484848;
                }

                h1 {
                    font-weight: normal;
                    font-size: 2.6rem !important;
                    color: #282828;
                    margin-bottom: 1.5rem;
                    letter-spacing: -1px;

                    strong {
                        color: #336699;
                        font-weight: 900;
                    }

                    @media (max-width: 768px) {
                        font-size: 2.2rem !important;
                        margin-bottom: 1rem;
                    }
                }

                > p {
                    font-size: 1.2rem;
                    line-height: 1.7rem;
                }

                .is-size-7 {
                    font-size: 0.85rem !important;
                }

                > p.legal-notice {
                    font-size: 0.75rem;
                    line-height: 1.2rem;
                    color: #999999;
                    margin-top: 2rem;
                }

                .signup {
                    border-top: 1px solid #e9e9e9;
                    padding-top: 1.5rem;
                    margin-top: 4rem;

                    .button {
                        padding-left: 1.3rem;
                    }

                    @media (max-width: 768px) {
                        margin-top: 2rem;
                    }
                }

                .requests {
                    border: 1px solid #e7e7e7;
                    border-radius: 8px;

                    .request-option {
                        padding: 1rem;
                        border-bottom: 1px solid #e7e7e7;

                        &.clickable {
                            &:hover {
                                background-color: #f4f4f4;
                                cursor: pointer;
                            }
                        }

                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }


                @media (max-width: 768px) {
                    border-radius: 5px 5px 0 0 ;
                    padding: 3rem 1rem 2.5rem 1rem;
                    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
                }
            }

            .right-side {
                background-color: #336699;
                background: linear-gradient(0deg, #214b76 0%, #336699 100%);
                border-radius: 0 5px 5px 0;
                padding: 4.8rem 2.5rem 4rem 3.5rem;
                position: relative;
                //min-height: 650px;
                color: white;

                .quick {
                    padding-right: 1rem;
                }

                h4 {
                    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    padding-bottom: 0.5rem;
                }

                .maximize {
                    border-radius: 0 5px 5px 0;
                    position: absolute;
                    bottom: 0;
                    padding: 0;

                    @media (max-width: 768px) {
                        display: none;
                    }
                }

                .logo-frame {
                    border: 2px solid #224C74;
                    background: white;
                    border-radius: 0.3rem;
                    padding: 1rem;
                    width: 180px;
                    height: 175px;

                    display: flex;
                    align-content: center;
                    align-items: center;
                    margin-bottom: 20px;

                    img {
                        width: 100%;
                    }
                }

                @media (max-width: 768px) {
                    border-radius: 0 0 5px 5px;
                    padding: 3rem 1rem 2.5rem 1rem;
                    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
                }
            }

            @media (max-width: 768px) {
                margin: 1rem;
                box-shadow: none;
            }
        }

        span.beta {
            color: #333;
            border: 1px solid #c2c2c2;
            border-radius: 3px;
            padding: 0 4px;
            font-size: 0.6rem;
            margin-left: 0.5rem;
            vertical-align: super;
            font-weight: normal;
            letter-spacing: normal;
        }

        @media (max-width: 768px) {
            align-items: normal;
            justify-content: normal;
        }

        .copyright {
            color: #f6f7fc;
            font-size: 12px;
            text-align: center;
        }
    }

    .alert-box {
        border: 2px solid orange;
        padding: 1rem 1rem;
        border-radius: 5px;
        margin-bottom: 1rem;
        font-size: 0.95rem;

        &.info {
            border: 2px solid #7596b2;
        }
    }
</style>
